import { Block, BlockContent, BlockTitle } from '../Block';
import {
  SlideTitleWrapper,
  SlideWrapper,
  WrapperButton,
  WrapperSlider,
  YoutubePlayer,
  YoutubePlayerSingle
} from './styles';

import ButtonWithLine from '../Button/ButtonWithLine';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Text from '../Typography/Text';
import dynamic from 'next/dynamic';
import { translate } from 'react-i18next';
import useMobile from '../../utils/useMobile';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

const SliderComponentWithNoSSR = dynamic(
  import('../../../src/components/Slider2022'),
  {
    // eslint-disable-next-line react/display-name
    loading: () => <div />,
    ssr: false
  }
);

const getYTId = url => {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return match && match[7].length == 11 ? match[7] : false;
};

const VideoGallery = ({ data, t, i18n }) => {
  const { isMobile } = useMobile();
  const { width } = useWindowDimensions();
  if (!data?.detail) return null;

  const showControls = useMemo(
    () => {
      if (width >= 1024) {
        if (data.slides.length > 3) {
          return true;
        }
        return false;
      }
      if (width >= 640) {
        if (data.slides.length > 2) {
          return true;
        }
        return false;
      }
      if (data.slides.length > 1) {
        return true;
      }
      return false;
    },
    [width]
  );

  return (
    <Block>
      {data.detail.title && <BlockTitle>{data.detail.title}</BlockTitle>}

      {data.detail.content && (
        <BlockContent wysiwyg>{data.detail.content}</BlockContent>
      )}
      <WrapperSlider>
        {data.slides.length > 1 ? (
          <SliderComponentWithNoSSR
            breakpoints={{
              0: {
                slidesPerView: 1
              },
              640: {
                slidesPerView: data.slides.length >= 2 ? 2 : data.slides.length
              },
              1024: {
                slidesPerView: data.slides.length >= 3 ? 3 : data.slides.length
              }
            }}
            showControls={showControls}
          >
            {data.slides.map(slide => (
              <SlideWrapper key={slide.id}>
                <YoutubePlayer
                  src={`https://www.youtube.com/embed/${getYTId(
                    (i18n.language === 'fr'
                      ? slide.video_url_fr
                      : slide.video_url_en) || ''
                  )}`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
                <SlideTitleWrapper>
                  <Text variant="body2">
                    {i18n.language === 'fr' ? slide.title_fr : slide.title_en}
                  </Text>
                </SlideTitleWrapper>
              </SlideWrapper>
            ))}
          </SliderComponentWithNoSSR>
        ) : (
          data.slides.map(slide => {
            const videoId =
              i18n.language === 'fr' ? slide.video_url_fr : slide.video_url_en;
            return (
              <SlideWrapper key={slide.id}>
                {videoId && (
                  <YoutubePlayerSingle
                    src={`https://www.youtube.com/embed/${getYTId(videoId)}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                )}
                <SlideTitleWrapper>
                  <Text variant="body2">
                    {i18n.language === 'fr' ? slide.title_fr : slide.title_en}
                  </Text>
                </SlideTitleWrapper>
              </SlideWrapper>
            );
          })
        )}
      </WrapperSlider>

      {data.detail.cta_url &&
        data.detail.cta_label && (
          <WrapperButton>
            <ButtonWithLine href={data.detail.cta_url}>
              {data.detail.cta_label}
            </ButtonWithLine>
          </WrapperButton>
        )}
    </Block>
  );
};

VideoGallery.propTypes = {
  title: PropTypes.string
};

export default translate()(VideoGallery);
